import { Avatar, ListItem, ListItemAvatar, ListItemText, useTheme } from "@mui/material";
import gradients from 'src/_utils/gradients';
import moment from "moment";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddCardIcon from '@mui/icons-material/AddCard';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import GroupIcon from '@mui/icons-material/Group';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PersonIcon from '@mui/icons-material/Person';
import ForumIcon from '@mui/icons-material/Forum';
import ErrorIcon from '@mui/icons-material/Error';
import BlockIcon from '@mui/icons-material/Block';
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import { CalendarToday, Receipt, SettingsBackupRestore, WalletOutlined, Warning, Notifications, RequestQuote, LocationOn, BadgeOutlined, CloudUpload } from "@mui/icons-material";
import { RequestPage } from "@mui/icons-material";
import { notificationRead } from "src/constants";
import ApprovalIcon from "@mui/icons-material/Approval";
import CancelIcon from "@mui/icons-material/Cancel";
export default function NoticationItem({
    notification,
    handleNotificationClick,
    notificationIndex,
    notificationsLength
}) {
    const theme = useTheme()
    const classes = {
        avatarBlue: {
            backgroundImage: gradients.blue
        },
        avatarGreen: {
            backgroundImage: gradients.green
        },
        avatarRed: {
            backgroundImage: gradients.red
        },
        avatarOrange: {
            backgroundImage: gradients.orange
        },
        avatarIndigo: {
            backgroundImage: gradients.indigo
        },
        avatarBrandBlue: {
            backgroundImage: gradients.brandBlue
        }
    }

    const avatars = {
        ACCOUNT_BLOCKED: (
            <Avatar sx={classes.avatarRed}>
                <BlockIcon />
            </Avatar>
        ),
        NEW_MERCHANT_REGISTER: (
            <Avatar sx={classes.avatarOrange}>
                <PersonIcon />
            </Avatar>
        ),
        NEW_CONTACT_US_MESSAGE: (
            <Avatar sx={classes.avatarBrandBlue}>
                <ForumIcon />
            </Avatar>
        ),
        LOCATION: (
            <Avatar sx={classes.avatarOrange}>
                <LocationOnIcon />
            </Avatar>
        ),
        SINGLE_ORDER: (
            <Avatar sx={classes.avatarBrandBlue}>
                <AddCardIcon />
            </Avatar>
        ),
        MULTI_ORDERS: (
            <Avatar sx={classes.avatarIndigo}>
                <DynamicFeedIcon />
            </Avatar>
        ),
        CONNECTION: (
            <Avatar sx={classes.avatarBlue}>
                <GroupIcon />
            </Avatar>
        ),
        ACCOUNT_ACTIVATED: (
            <Avatar sx={classes.avatarGreen}>
                <CheckCircleOutlineIcon />
            </Avatar>
        ),
        SUCCESSFUL: (
            <Avatar sx={classes.avatarGreen}>
                <CheckCircleIcon />
            </Avatar>
        ),
        FAILED: (
            <Avatar sx={classes.avatarRed}>
                <ErrorIcon />
            </Avatar>
        ),
        ORDER_REMOVED: (
            <Avatar sx={classes.avatarRed}>
                <ErrorIcon />
            </Avatar>
        ),
        TASK_FAILED: (
            <Avatar sx={classes.avatarRed}>
                <ErrorIcon />
            </Avatar>
        ),
        NEW_TASK: (
            <Avatar sx={classes.avatarBrandBlue}>
                <AddCardIcon />
            </Avatar>
        ),
        MULTI_TASKS: (
            <Avatar sx={classes.avatarIndigo}>
                <DynamicFeedIcon />
            </Avatar>
        ),
        NEW_POTENTIAL_FREELANCE_REGISTER: (
            <Avatar sx={classes.avatarBrandBlue}>
                <SportsMotorsportsIcon />
            </Avatar>
        ),
        EZPAY_INTEGRATION: (
            <Avatar sx={classes.avatarGreen}>
                <CheckCircleIcon />
            </Avatar>
        ),
        NEW_FREE_DEMO_REQUEST: (
            <Avatar sx={classes.avatarBrandBlue}>
                <RequestPage />
            </Avatar>
        ),
        ORDER_RESCHEDULE: (
            <Avatar sx={classes.avatarBrandBlue}>
                <CalendarToday />
            </Avatar>
        ),
        ORDER_CANCELED: (
            <Avatar sx={classes.avatarRed}>
                <ErrorIcon />
            </Avatar>
        ),
        CANCEL_ORDER_FAILED: (
            <Avatar sx={classes.avatarRed}>
                <ErrorIcon />
            </Avatar>
        ),
        SHIPMENT_FAILED: (
            <Avatar sx={classes.avatarRed}>
                <ErrorIcon />
            </Avatar>
        ),
        WALLET_RECHARGE: (
            <Avatar sx={classes.avatarBrandBlue}>
                <WalletOutlined />
            </Avatar>
        ),
        ORDER_RETURN: (
            <Avatar sx={classes.avatarBrandBlue}>
                <SettingsBackupRestore />
            </Avatar>
        ),
        COD_INVOICE_SETTLED: (
            <Avatar sx={classes.avatarBrandBlue}>
                <Receipt />
            </Avatar>
        ),
        REMINDER_ORDER_ASSIGN_DRIVER: (
            <Avatar sx={classes.avatarOrange}>
                <Warning />
            </Avatar>
        ),
        MAPIT_ADMIN: (
            <Avatar sx={classes.avatarBrandBlue}>
                <Notifications />
            </Avatar>
        ),
        COD_WITHDRAWAL_REQUEST: (
            <Avatar sx={classes.avatarBrandBlue}>
                <RequestQuote />
            </Avatar>
        ),
        NATIONAL_ADDRESS: (
            <Avatar sx={classes.avatarBrandBlue}>
                <LocationOn />
            </Avatar>
        ),
        SATCHELS_SHIPMENT_CANCELED: (
            <Avatar sx={classes.avatarRed}>
                <BadgeOutlined />
            </Avatar>
        ),
        SATCHELS_SHIPMENT_RETURNED: (
            <Avatar sx={classes.avatarOrange}>
                <BadgeOutlined />
            </Avatar>
        ),
        SATCHELS_SHIPMENT_COMPLETED: (
            <Avatar sx={classes.avatarGreen}>
                <BadgeOutlined />
            </Avatar>
        ),
        UPLOAD_TRANSACTION_FILE: (
            <Avatar sx={classes.avatarGreen}>
                <CloudUpload />
            </Avatar>
        ),
        COMMERCIAL_DATA_REQUEST :(
          <Avatar sx={classes.avatarOrange}>
            <ApprovalIcon />
          </Avatar>
        ),
        COMMERCIAL_DATA_APPROVED : (
            <Avatar sx={classes.avatarGreen}>
            <CheckCircleIcon  />
          </Avatar>
        ),
        COMMERCIAL_DATA_REJECTED : (
            <Avatar sx={classes.avatarRed}>
            <CancelIcon />
          </Avatar>
        ),
        SHIPMENT_CREATION_FAILED :(
            <Avatar sx={classes.avatarRed}>
            <CancelIcon />
          </Avatar>
        )
    };

    const getAvatar = (notification) => {
        let IconName = ''
        if (notification.type.includes("CONNECTION")) {
            IconName = 'CONNECTION'
        } else if (notification.type === "ORDER_COMPLETED") {
            if (notification.body_en.includes("successfully")) {
                IconName = "SUCCESSFUL"
            }
            if (notification.body_en.includes("failed")) {
                IconName = "FAILED"
            }
        } else {
            IconName = notification.type
        }
        return avatars[IconName]
    }
    return (
        <ListItem
            sx={() => ({
                cursor: "pointer",
                bgcolor: notification.read === notificationRead.CLICKED ? "#FFFFFF" : "#e9f3fe",
                "&:hover": {
                    bgcolor: "#f0f2f5"
                }
            })}
            divider={notificationIndex < notificationsLength - 1}
            key={notification.id}
            onClick={_ => handleNotificationClick(notification)}
        >
            <ListItemAvatar>{getAvatar(notification)}</ListItemAvatar>
            <ListItemText
                primary={theme.direction === "rtl" ? notification.body_ar : notification.body_en}
                primaryTypographyProps={{ variant: 'body2', sx: { color: "text.dark", textAlign: "start" } }}
                secondary={moment(notification.createdAt).fromNow()}
                secondaryTypographyProps={{ variant: 'subtitle1', sx: { color: "text.dark", textAlign: "start" } }}
            />
            <ArrowForwardIcon
                sx={() => ({
                    transform: theme.direction === 'rtl' ? 'scale(-1, 1)' : '',
                    color: "text.dark"
                })}
            />
        </ListItem>
    )
}
